export const truncateContents = (content) => {
  if (content.length > 20) {
    return content.slice(0, 20) + "...";
  }
  return content;
};
